import { BaseComponent } from 'components/BaseComponent';
import PropTypes, { object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import { formatCurrency } from '../../../utils/string';
import { WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT } from '../constants';
import {
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
  VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
} from '../../Vehicles/constants';
import { selectWork } from '../../Api/selectors';
import { Loader } from 'react-feather';
import { PURCHASING_DATA_CRUD, PURCHASING_PRICES_CRUD } from '../../../components/Permission/constants';
import { InvoiceStatus } from '../../Invoices/components/InvoiceStatus';
import { getDate } from '../../Vehicles/helpers';
import { fetchWebloginVehicleBuyingContact, fetchWebloginVehicleInvoice } from '../actions';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .status-label {
    width: fit-content;
  }

  .cell-value {
    white-space: nowrap;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
  }
`;

const STATE = {
  isOpen: false,
  incomingInvoice: null,
  userBuyer: null,
};
/* eslint-disable react/prefer-stateless-function */
class WebloginVehicleFinancePurchaseCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchWebloginVehicleBuyingContact(res => {
      if (res?.id) {
        const { name, surname } = res.props;
        this.setState({ userBuyer: { id: res.id, name: name.value, surname: surname.value } });
      }
    });

    this.props.fetchWebloginVehicleInvoice(res => {
      if (res?.id) {
        this.setState({ incomingInvoice: res });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.vehicle?.user_buyer_id && !this.state.userBuyer) {
      this.props.fetchWebloginVehicleBuyingContact(res => {
        if (res?.id) {
          const { name, surname } = res.props;
          this.setState({ userBuyer: { id: res.id, name: name.value, surname: surname.value } });
        }
      });
    }
    if (this.props.vehicle.incoming_invoice && !this.state.incomingInvoice) {
      this.props.fetchWebloginVehicleInvoice(res => {
        if (res?.id) {
          this.setState({ incomingInvoice: res });
        }
      });
    }
  }

  get purchasingDataProps() {
    return ['creditor_company', 'user_buyer_id'];
  }

  get purchasingPricesProps() {
    return [
      'vehicle_purpose',
      'tax_type',
      'economic_prize',
      ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW,
      ...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE,
    ];
  }

  renderField(property, data) {
    const { vehicle, economicPrize, creditorCompany } = data;

    // if (property == 'creditor_company') {
    //   return (
    //     vehicle[property] && (
    //       <Row key={property}>
    //         <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
    //         <Cell>
    //           <Link>{`${getPropByName(creditorCompany, 'name') || ''}`}</Link>
    //         </Cell>
    //       </Row>
    //     )
    //   );
    // }

    if (property == 'user_buyer_id') {
      return (
        <Row key={property}>
          <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
          {this.props.workUser ? (
            <Loader small />
          ) : (
            <Cell>{`${this.state.userBuyer?.name || ''} ${this.state.userBuyer?.surname || ''}`}</Cell>
          )}
        </Row>
      );
    }

    if (
      property == 'financial_purchase_price_marge_bpm' ||
      property == 'rest_bpm' ||
      property == 'financial_purchase_price_marge_excl_bpm' ||
      property == 'financial_bpm_gross' ||
      property == 'financial_purchase_price_incl_vat_bpm' ||
      property == 'financial_purchase_price_incl_vat_excl_bpm' ||
      property == 'vat_amount' ||
      property == 'financial_purchase_price_excl_vat_excl_bpm' ||
      property == 'financial_bpm_gross' ||
      property == 'economic_prize'
    ) {
      if (property == 'economic_prize') {
        return (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-value">{formatCurrency(economicPrize)}</Cell>
          </Row>
        );
      }

      if (property == 'rest_bpm') {
        const isShowRestBpm = vehicle?.vehicle_purpose !== 'commercial' && vehicle[property];
        return (
          isShowRestBpm && (
            <Row key={property}>
              <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
              <Cell className="cell-value">{formatCurrency(vehicle[property])}</Cell>
            </Row>
          )
        );
      }
      return (
        vehicle[property] && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
            <Cell className="cell-value">{formatCurrency(vehicle[property])}</Cell>
          </Row>
        )
      );
    }

    if (property == 'paymentStatus') {
      return (
        this.state.incomingInvoice?.status?.name && (
          <Row key={property}>
            <Cell>{this.lbl(`vehicle.info.finance.payment_status`)}</Cell>
            {this.props.workInvoice ? (
              <Loader small />
            ) : (
              <Cell>
                <InvoiceStatus className="status-label" status={this.state.incomingInvoice?.status?.name} />
              </Cell>
            )}
          </Row>
        )
      );
    }

    return (
      vehicle[property] && (
        <Row key={property}>
          <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
          <Cell className="cell-value">{this.lbl(`vehicle.property.${property}.${vehicle[property]}`)}</Cell>
        </Row>
      )
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const { incomingInvoice } = this.state;
    const creditorCompany = vehicle.creditorCompany;
    let economicPrize = null;
    let typesArr = ['user_buyer_id', 'vehicle_purpose', 'tax_type'];
    if (vehicle['tax_type'] === 'BTW') {
      economicPrize = (+vehicle?.financial_purchase_price_incl_vat_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
      typesArr = typesArr.concat(...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_BTW);
    }
    if (vehicle['tax_type'] === 'marge') {
      economicPrize = (+vehicle?.financial_purchase_price_marge_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
      typesArr = typesArr.concat(...VEHICLE_FINANCIAL_PURCHASE_PRICE_TYPES_MARGE);
    }
    const data = {
      vehicle,
      economicPrize,
      creditorCompany,
    };

    return (
      <Container>
      <Card className="vehicle-info-card info-card data">
      
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.finance.purchase.purchasing_data')}</h2>

            {window.innerWidth <= 768 && (<div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>)}
            
          </HBox>
          {(this.state.isOpen || window.innerWidth > 768) && (
            <List>
              {[...typesArr, 'paymentStatus'].map(property => {
                let permission = null;
                if (this.purchasingDataProps.includes(property)) permission = PURCHASING_DATA_CRUD;
                if (this.purchasingPricesProps.includes(property)) permission = PURCHASING_PRICES_CRUD;

                return this.renderField(property, data);
              })}
              {/* <Row>
                <Cell>{this.lbl(`vehicle.property.orb_incoming_complete`)}</Cell>
                <Cell>{getDate(vehicle?.purchase_release_done_date)}</Cell>
              </Row> */}
            </List>
           )} 
        
      </Card>
      </Container>
    );
  }
}

WebloginVehicleFinancePurchaseCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workUser: selectWork(`${WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT}-${ownProps.vehicle?.id}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchWebloginVehicleInvoice(callback) {
      if (ownProps.vehicle?.incoming_invoice) {
        dispatch(fetchWebloginVehicleInvoice(ownProps.vehicle?.id, ownProps.vehicle?.incoming_invoice, callback));
      }
    },
    fetchWebloginVehicleBuyingContact(callback) {
      dispatch(fetchWebloginVehicleBuyingContact(ownProps.vehicle?.id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebloginVehicleFinancePurchaseCard = compose(withConnect, withRouter)(WebloginVehicleFinancePurchaseCardComp);
